import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";

const PricingSection = () => {
  const { t } = useTranslation();

  return (
    <section id="pricing" className="py-24 bg-muted/10">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-foreground mb-4">
            {t('pricing.title')} <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">{t('pricing.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-muted-foreground mb-8">{t('pricing.subtitle')}</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="border-primary shadow-2xl bg-gradient-to-br from-primary/5 to-secondary/5">
            <CardHeader className="text-center pb-8">
              <div className="flex items-baseline justify-center space-x-2 mb-4">
                <span className="text-6xl font-bold text-foreground">$0.09</span>
                <span className="text-2xl text-muted-foreground">/minute</span>
              </div>
              <CardTitle className="text-2xl text-muted-foreground">
                {t('pricing.allFeatures')}
              </CardTitle>
            </CardHeader>
            
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                {Array.from({ length: 14 }, (_, i) => i).map((index) => (
                  <div key={index} className="flex items-center space-x-3">
                    <Check className="w-5 h-5 text-secondary flex-shrink-0" />
                    <span className="text-foreground">{t(`pricing.features.${index}`)}</span>
                  </div>
                ))}
              </div>
              
              <Button
                className="w-full bg-gradient-to-r from-primary to-secondary hover:opacity-90"
                size="lg"
                onClick={() => window.location.href = 'https://manage.call24x7.ai/signup'}
              >
                {t('pricing.getStarted')}
              </Button>
            </CardContent>
          </Card>
        </div>

        {/* Additional Info */}
        <div className="text-center mt-16">
          <p className="text-muted-foreground mb-4">{t('pricing.freeTrial')}</p>
          <div className="flex flex-wrap justify-center gap-8 text-sm text-muted-foreground">
            <span className="flex items-center gap-2"><Check className="w-4 h-4 text-secondary" /> {t('pricing.benefits.0')}</span>
            <span className="flex items-center gap-2"><Check className="w-4 h-4 text-secondary" /> {t('pricing.benefits.1')}</span>
            <span className="flex items-center gap-2"><Check className="w-4 h-4 text-secondary" /> {t('pricing.benefits.2')}</span>
            <span className="flex items-center gap-2"><Check className="w-4 h-4 text-secondary" /> {t('pricing.benefits.3')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
